var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"img-group"},[_c('img',{attrs:{"src":_vm.$store.state.static_img_url + 'pic/pc3.5/404_h5.png'}}),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc-p"},[_c('p',[_vm._v("非常抱歉~")]),_c('p',[_vm._v("当前页面暂不支持手机浏览器打开"),_c('br'),_vm._v("请访问电脑端网站查看")])])
}]

export { render, staticRenderFns }